import {
  SET_SELECTED_TEAM,
  SET_SELECTED_DATABOX,
  SET_DATABOX_DOCUMENTS,
  SET_PAGE_SIZE,
  SET_TEAM_TAGS,
  SET_IS_DRAWER_OPEN,
  SET_CREATE_DATA_BOX_STATE,
  SET_DATA_BOX_EDIT_MODE,
  SET_ALL_DATA_BOXES,
  SET_ALL_SETTING_OPS,
  SET_ALL_TEAMS,
  RELOAD_TEAMS,
  SET_PLAIN_DATABOXES,
  SET_CURRENT_THREAD,
  SET_ALL_CATEGORIES,
  SET_ALL_TAG_LEVELS
} from '../constants/databoxConstants'

const initialState = {
  selectedTeam: undefined,
  selectedDatabox: undefined,
  databoxDocuments: undefined,
  pageSize: 10, // can be converted to object for table related properties like sort direction,sortBy
  totalRows: 0,
  teamTags: [],
  dataBoxesState: {
    dataBoxes: [],
    isLoading: false
  },
  databoxSettings: {},
  isDataBoxDrawerOpen: false,
  createDataBoxState: {
    dataBoxDetails: {},
    inProgress: false
  },
  dataBoxEditModeData: {
    dataBoxDetails: {},
    dataBoxEditMode: false, // flag to indicate edit mode, reset it if update successful
    isLoading: false // flag to indicate API call in progress to fech latest databox details
  },
  categories: [],
  tagLevels: [],
  tagNameById: {},
  teams: [],
  appVersion: '',
  dataBoxTeam: {},
  reloadTeams: false,
  plainDataBoxes: [],
  currentThread: {
    threadId: null,
    currentThreadMcpServerId: null,
    scopeconfiguration: {},
    details: null
  }
}

const databoxReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_TEAM:
      return { ...state, selectedTeam: action.payload }
    case SET_SELECTED_DATABOX:
      return { ...state, selectedDatabox: action.payload }
    case SET_DATABOX_DOCUMENTS:
      return {
        ...state,
        databoxDocuments: action.payload.rows,
        totalRows: action.payload.totalRows
        // TODO:- add search query to fix issue query string issue.
      }
    case SET_PAGE_SIZE:
      return { ...state, pageSize: action.payload }

    case SET_TEAM_TAGS:
      return { ...state, teamTags: action.payload }

    case SET_ALL_DATA_BOXES:
      return {
        ...state,
        dataBoxesState: {
          dataBoxes: action?.data?.dataBoxes,
          isLoading: action?.data?.isLoading
        }
      }
    case SET_PLAIN_DATABOXES: {
      const payload = Array.isArray(action?.data) ? action.data : Array.isArray(action?.data?.data) ? action.data.data : null
      return {
        ...state,
        plainDataBoxes: payload && payload.length > 0 ? payload : payload === null ? [] : state.plainDataBoxes
      }
    }
    case SET_ALL_SETTING_OPS:
      return { ...state, databoxSettings: action.data }
    case SET_IS_DRAWER_OPEN:
      return { ...state, isDataBoxDrawerOpen: action.data }
    case SET_CREATE_DATA_BOX_STATE:
      return {
        ...state,
        createDataBoxState: {
          dataBoxDetails: action.data.details,
          inProgress: action.data.inProgress
        }
      }
    case SET_DATA_BOX_EDIT_MODE:
      return {
        ...state,
        dataBoxEditModeData: { ...action.data }
      }
    case SET_ALL_CATEGORIES:
      return { ...state, categories: action.data }
    case SET_ALL_TAG_LEVELS:
      const tagNameById = {}
      action.data.forEach((tagLevel) => {
        tagLevel.tags.forEach((tag) => {
          tagNameById[tag.id] = { ...tag, tagLevelName: tagLevel.name }
        })
      })
      return { ...state, tagLevels: action.data, tagNameById }

    case SET_ALL_TEAMS:
      return { ...state, teams: action.data }

    // case SET_APP_VERSION: {
    //   return { ...state, appVersion: action.data }
    // }

    // case SET_DATABOX_TEAM: {
    //   return { ...state, dataBoxTeam: action.data }
    // }

    // case RESET_DATABOX_DATA: {
    //   return { ...initialState }
    // }

    case RELOAD_TEAMS: {
      return { ...state, reloadTeams: action.data }
    }

    case SET_CURRENT_THREAD:
      console.log('Setting current thread in reducer with data: ', action?.payload ?? {})
      return {
        ...state,
        currentThread: {
          threadId: action?.payload?.threadId ?? null,
          currentThreadMcpServerId: action?.payload?.currentThreadMcpServerId ?? null,
          scopeconfiguration: action?.payload?.scopeconfiguration ?? {},
          details: (action?.payload && 'details' in action.payload)
            ? action.payload.details
            : (state.currentThread?.details ?? null)
        }
      }

    default:
      return state
  }
}

export default databoxReducer
